import React from "react";

function AttentionInvestor() {
  return (
    <section className="attentionInvestor">
      <div className="attentionHeaders">
        <ul className="attentionLists" style={{ textAlign: "left" }}>
          <li className="attentionList">
            <h4 className="attentionTitle">ATTENTION INVESTORS:</h4>
          </li>
          <li className="list">
            <h4>IPO</h4>
          </li>
          <li className="list">
            <h4>KYC</h4>
          </li>
        </ul>
      </div>

      <div className="scrolling_Text">
        <p className="scroll">
          Prevent unauthorized transactions in your account - Update your
          mobile numbers/email IDs with your Stock Brokers. Receive
          information of your transactions directly from Exchange on your
          mobile/email at the end of the day. Issued in the interest of
          investors. Prevent Unauthorized Transactions in your demat account -
          Update your Mobile Number with your Depository Participant. Receive
          alerts on your Registered Mobile for all debit and other important
          transactions in your demat account directly from NSDL/CDSL on the
          same day. Issued in the interest of investors.
        </p>
      </div>
    </section>
  );
}

export default AttentionInvestor;
